import { makeStyles } from "@material-ui/core/styles";
import { useIsAr } from "../../../../../Hooks";

export default makeStyles((theme) => {
  const { isAr } = useIsAr(theme.direction);

  return {
    flex: {
      display: "flex",
      gap: "4px",
      width: "244px",
      height: "83px",
      padding: "16px",
      alignItems: "center",
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.background.gray_200}`,

      boxShadow: "0px 12px 16px -4px #10182814",
    },
    actionsContainer: (props) => ({
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: 50,
    }),
    button: {
      minWidth: "fit-content",
      padding: "10px",
      borderRadius: "6px",
    },
    disabledButton: {
      backgroundColor: theme.palette.background.secondary_disabled,
      "& svg path": {
        fill: theme.palette.text.secondary_disabled,
      },
    },
  };
});
